import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useClientId } from '../../../_hooks/useClientId';
import { AllocationTaxStatusDTO } from './useAccountsQuery';

interface FetcherParams {
  accountId?: string;
  clientId: number;
}

interface AssetAllocationDTO {
  id: number;
  name: string;
  y: number;
  color_group: number;
  color: string;
}

interface AssetAllocationTaxStatusesDTO {
  Label: string;
  Value: number;
}

export interface AssetAllocationContentDTO {
  AssetAllocation: AssetAllocationDTO[];
  SpecificPositionsAssetAllocation: AssetAllocationDTO[];
}

export type AssetAllocationsByTaxStatusDTO = Record<
  AllocationTaxStatusDTO,
  AssetAllocationContentDTO
>;

export interface AccountPortfolioDTO {
  AssetAllocation: AssetAllocationDTO[];
  HypotheticalReturn: number | null;
  ShowHypotheticalReturn: boolean;
  AssetAllocationTaxStatuses: AssetAllocationTaxStatusesDTO[];
  AssetAllocationsByTaxStatus: AssetAllocationsByTaxStatusDTO;
}

const fetchAccountPortfolio = ({
  clientId,
  accountId,
}: FetcherParams): Promise<AccountPortfolioDTO> => {
  return authFetch(
    urlWithParams('/Consumer/AccountPortfolio', {
      clientId,
      accountId,
    }),
  );
};

interface QueryParams {
  accountId?: string;
  onError?(): void;
}

export const useAccountPortfolioQuery = ({ accountId, onError }: QueryParams) => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.accountPortfolio(clientId, accountId),
    () => fetchAccountPortfolio({ clientId, accountId }),
    { cacheTime: 0, enabled: !!accountId, onError },
  );
};
